import { useContext } from 'react';

import { ControlsServiceContext } from '../../../automaticPanel/panelsService/ControlsServiceContext';

export function useControlService() {
  const { service } = useContext(ControlsServiceContext);
  return service;
}
